import { MDBTable, MDBTableBody } from "mdbreact";
import React from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

function CropInsuranceDataModal({ modal, toggleCriteria }) {
  return (
    <>
      <Modal
        isOpen={modal}
        toggle={toggleCriteria}
        style={{ maxWidth: "800px" }}
        centered
      >
        <ModalHeader toggle={toggleCriteria}>
          <h5 style={{ fontWeight: "bold" }}>Crop Insurance Data Criteria</h5>
        </ModalHeader>
        <ModalBody>
          <table className="table table-bordered">
            <MDBTableBody>
              <tr>
                <th style={{ fontSize: "1rem", backgroundColor: "#f6fbfd" }}>
                  Item
                </th>
                <th style={{ fontSize: "1rem", backgroundColor: "#f6fbfd" }}>
                  Criteria
                </th>
                <th style={{ fontSize: "1rem", backgroundColor: "#f6fbfd" }}>
                  Score
                </th>
              </tr>

              <tr>
                <td>Insurance History</td>
                <td>
                  <tr>Yes</tr>
                  <tr>No</tr>
                </td>
                <td>
                  <tr>4</tr>
                  <tr>2</tr>
                </td>
              </tr>

              <tr>
                <td>No. of claims made against insurance</td>
                <td>
                  <tr>0%</tr>
                  <tr>{"<=40 %"}</tr>
                  <tr>{"<=70 %"}</tr>
                  <tr>100%</tr>
                </td>
                <td>
                  <tr>4</tr>
                  <tr>3</tr>
                  <tr>2</tr>
                  <tr>1</tr>
                </td>
              </tr>
            </MDBTableBody>
          </table>
        </ModalBody>
        {/* <ModalFooter> */}
        {/* <Button color="secondary" onClick={toggleCriteria}>
            Cancel
          </Button> */}
        {/* </ModalFooter> */}
      </Modal>
    </>
  );
}

export default CropInsuranceDataModal;
